/**
 * Public navigation config powering the responsive mega-menu + mobile drawer.
 * Columns drive the dropdown panels.
 */
export const PRIMARY_NAV = [
  {
    label: 'About',
    to: '/about',
    columns: [
      {
        heading: 'Who We Are',
        links: [
          { label: 'Mission & Vision', to: '/about#mission' },
          { label: 'Meet Area 1 Officers & Presidents', to: '/leadership' },
          { label: 'Member Clubs', to: '/clubs' },
          { label: 'Organization Structure', to: '/about#structure' },
          { label: 'Our History', to: '/about#history' },
        ],
      },
    ],
  },
  {
    label: 'Stories',
    to: '/stories',
    columns: [
      {
        heading: 'Impact Stories',
        links: [
          { label: 'All Stories', to: '/stories' },
          { label: 'Featured', to: '/stories?featured=1' },
          { label: 'News & Highlights', to: '/news' },
        ],
      },
    ],
  },
  {
    label: 'Get Involved',
    to: '/activities',
    columns: [
      {
        heading: 'Activities & Events',
        links: [
          { label: 'Activities', to: '/activities' },
          { label: 'Events', to: '/events' },
          { label: 'Calendar', to: '/calendar' },
        ],
      },
    ],
  },
  {
    label: 'Resources',
    to: '/media',
    columns: [
      {
        heading: 'Media & Resources',
        links: [
          { label: 'Media Center', to: '/media' },
          { label: 'Downloads', to: '/media?type=document' },
        ],
      },
    ],
  },
  { label: 'Contact', to: '/contact' },
];

// Only the accounts the Area actually runs. Add an entry here (with a matching
// icon in components/SocialIcon.jsx) when another channel goes live.
export const SOCIAL_LINKS = [
  { label: 'Facebook', href: 'https://facebook.com/zontadistrict17area1', icon: 'facebook' },
];
